import React, {useRef, useState, useEffect} from "react";
import {observer, inject} from "mobx-react";

import {Formik, Form, useField} from 'formik';
import * as Yup from 'yup';
import {TextInput, TextArea, CheckboxInput, TextLabel} from "@components/Form/FormFields";
import {SelectInput} from "../Form/FormFields";


@inject("store")
@observer
export default class MyProfile extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            myProfile: null,
            customerAccount: null
        };
    }

    componentDidMount() {

        this.props.store.beriksson.myProfile().then(res => {
            this.setState({myProfile: res})
        })
    }

    render() {
        if (!this.props.store.navigation.getCustomerId()) {
            return <div>Error: No customer choosen</div>;
        }

        return (
            <div
            >
                <div className="row">
                    <div className="col-12">
                        {this.state.myProfile && <MyProfileForm
                            myProfile={this.state.myProfile}
                            berikssonStore={this.props.store.beriksson}
                            navigation={this.props.store.navigation}
                        />}
                    </div>
                </div>


            </div>);

    }
}


const MyProfileForm = ({...props}) => {

    return (
        <Formik
            validateOnMount={true}
            enableReinitialize={true}
            initialValues={{
                cultureCode: props.cultureCode,
                nodeId: props.nodeId,
                firstName: props.myProfile.FirstName,
                lastName: props.myProfile.LastName,
                email: props.myProfile.Email,
                phoneNumber: props.myProfile.PhoneNumber,
                mobilePhoneNumber: props.myProfile.MobilePhoneNumber,
            }}
            validationSchema={Yup.object({

                firstName: Yup.string()
                    .required('Måste anges'),
                lastName: Yup.string()
                    .required('Måste anges'),
                
                phoneNumber: Yup.string()
                    .required('Måste anges'),
                
                

                
            })}
            //onSubmit={onSubmitWithReCAPTCHA}
            onSubmit={(values, {setSubmitting}) => {
                //alert(JSON.stringify(values, null, 2));
                props.berikssonStore.myProfileUpdate(values).then(res => {
                        props.navigation.toast("Uppgifterna sparades");
                        setSubmitting(false);
                    },
                    errorResponse => {
                        let errorMessage = "Ett fel uppstod:";
                        errorResponse.errors.forEach(x=> errorMessage += "\r\n- " + x)
                        props.navigation.toastError(errorMessage);
                        setSubmitting(false);
                    }
                )
            }}

        >
            {({values, setSubmitting, isSubmitting, handleBlur, setFieldValue, isValid}) => {
                //  noValidate
                return <Form>
                    <h4 className="text-normal pt-4">Min profil</h4>
                    <hr className="mb-3"/>
                    <div className={"row"}>
                        <div className={"col-sm-4"}>
                            <TextInput
                                label="Förnamn"
                                name="firstName"
                                type="text"
                            /></div>
                        <div className={"col-sm-4"}>
                            <TextInput
                                label="Efternamn"
                                name="lastName"
                                type="text"
                            /></div>
                    </div>

                    <div className={"row"}>
                        <div className={"col-sm-4"}>
                            <TextLabel
                                disabled
                                label="Epostadress"
                                name="email"
                                type="text"

                            /></div>
                    </div>

                    <div className={"row"}>
                        <div className={"col-sm-4"}>
                            <TextInput
                                label="Telefonnummer"
                                name="phoneNumber"
                                type="text"
                            /></div>
                        <div className={"col-sm-4"}>
                            <TextInput
                                label="Mobiltelefonnummer"
                                name="mobilePhoneNumber"
                                type="text"
                            /></div>
                    </div>

                    <button className="btn btn-success"
                            type="submit"
                            disabled={isSubmitting || !isValid}>Spara
                    </button>

                </Form>
            }
            }
        </Formik>
    );
};
